(function () {
  function publishConfirmedSignup(root) {
    if (!root.querySelector('[data-ps-launch-signup-success]')) return;
    var analytics = window.PSTAnalytics;
    if (!analytics || !analytics.analyticsAllowed()) return;
    var key = 'pst_waitlist_signup_succeeded';
    try {
      if (window.sessionStorage.getItem(key) === 'true') return;
    } catch (error) { }
    if (!analytics.emit(key, { placement: 'prelaunch_waitlist', form_type: 'customer' }, { onceKey: 'prelaunch_waitlist' })) return;
    try { window.sessionStorage.setItem(key, 'true'); } catch (error) { }
  }

  function initialize(root) {
    publishConfirmedSignup(root);
    root.querySelectorAll('[data-ps-launch-zoom-open]').forEach(function (trigger) {
      if (trigger.dataset.psLaunchZoomReady === 'true') return;
      var dialog = document.getElementById(trigger.getAttribute('aria-controls'));
      if (!dialog || typeof dialog.showModal !== 'function') return;
      var close = dialog.querySelector('[data-ps-launch-zoom-close]');
      var toggle = dialog.querySelector('[data-ps-launch-zoom-toggle]');
      var viewport = dialog.querySelector('[data-ps-launch-zoom-viewport]');
      if (!close || !toggle || !viewport) return;
      trigger.dataset.psLaunchZoomReady = 'true';

      trigger.addEventListener('click', function (event) {
        event.preventDefault();
        dialog.showModal();
        close.focus();
      });
      close.addEventListener('click', function () { dialog.close(); });
      dialog.addEventListener('click', function (event) {
        if (event.target === dialog) dialog.close();
      });
      dialog.addEventListener('close', function () {
        viewport.classList.remove('is-zoomed');
        viewport.scrollTo(0, 0);
        toggle.setAttribute('aria-pressed', 'false');
        toggle.textContent = toggle.dataset.zoomLabel;
        if (trigger.isConnected) trigger.focus();
      });
      toggle.addEventListener('click', function () {
        var zoomed = viewport.classList.toggle('is-zoomed');
        viewport.scrollTo(0, 0);
        toggle.setAttribute('aria-pressed', String(zoomed));
        toggle.textContent = zoomed ? toggle.dataset.fitLabel : toggle.dataset.zoomLabel;
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initialize(document); }, { once: true });
  } else {
    initialize(document);
  }
  document.addEventListener('shopify:section:load', function (event) { initialize(event.target); });
  document.addEventListener('pst:privacy-ready', function () { publishConfirmedSignup(document); });
  document.addEventListener('visitorConsentCollected', function () { publishConfirmedSignup(document); });
})();
